
        <div class="sidebar">
            <a
                *ngFor="let app of apps"
                class="sidebar-link"
                [ngClass]="{ active: app.active }"
                href="{{ app.url }}"
            >
                <div class="sidebar-icon">
                    <i class="fas fa-fw {{ app.icon }}"></i>
                </div>
                <div class="sidebar-label">{{ app.name }}</div>
            </a>
            <div *ngIf="apps.length === 0">
                <a class="sidebar-link" *ngFor="let i of [1, 2, 3, 4, 5]">
                    <div><i class="fas fa-square shimmer"></i></div>
                    <div><i class="fas fa-minus shimmer"></i></div>
                </a>
            </div>
        </div>
    